import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Grid,
  Avatar,
  makeStyles,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  gridItem: {
    textAlign: "left",
  },
  valueText: {
    marginTop: theme.spacing(1),
  },
}));

const OpenSuccessDialog = (props) => {
  const { openDialog, updatedData, handleCloseSuccessDialog } = props;
  const classes = useStyles();
  //   console.log("updatedData",updatedData);

  return (
    <Dialog open={openDialog} maxWidth="sm" fullWidth>
      <DialogContent className={classes.dialogContent}>
        <CheckCircleIcon className={classes.avatar} />

        <Typography variant="h6" style={{ marginTop: "10px" }}>
          New Network Created Successfully
        </Typography>
        <Typography variant="body1" style={{ marginTop: "10px" }}>
          The invitation has been sent to the user via email.
        </Typography>
        <Grid container spacing={2} style={{ marginTop: "20px" }}>
          <Grid item xs={6} className={classes.gridItem}>
            <Typography>
              <strong>Sponsor Name</strong>
            </Typography>
            <Typography className={classes.valueText}>
              {updatedData.data.sponsorName}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ textAlign: "right" }}
            className={classes.gridItem}
          >
            <Typography>
              <strong>Organization Code</strong>
            </Typography>
            <Typography className={classes.valueText}>
              {updatedData.data.organizationCode}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.gridItem}>
            <Typography>
              <strong>Sponsor Admin Email</strong>
            </Typography>
            <Typography className={classes.valueText}>
              {updatedData.data.sponsorAdminEmail}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ textAlign: "right" }}
            className={classes.gridItem}
          >
            <Typography>
              <strong>Network Type ID</strong>
            </Typography>
            <Typography className={classes.valueText}>
              {updatedData.data.networkTypeId}
            </Typography>
          </Grid>
        </Grid>
        <DialogActions className={classes.dialogActions}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<ChevronRight />}
            style={{
              borderRadius: "20px",
              textTransform: "none",
            }}
            onClick={handleCloseSuccessDialog}
          >
            OK
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default OpenSuccessDialog;
